import React from 'react'
import ScholarshipTable from './ApplyScholarship/ScholarshipTable'


function ApplyScholarship() {
  return (
    <div className='section-process-content upload-doc-con h-full w-full flex flex-col justify-center items-center'> 


           <div className='w-5/6 con-main-table-inner'>
               <ScholarshipTable/>
           </div>

     <div className="mt-10 text-center text-slate-400 text-xs md:text-sm">
        Powered by <span className="font-semibold text-slate-600">MastermindTech</span>
      </div>
    </div>
  )   
}

export default ApplyScholarship